import React, { Fragment, Suspense, lazy } from 'react';

const Transition = lazy(() => import('@headlessui/react').then((module) => ({ default: module.Transition })));
const TransitionChild = lazy(() => import('@headlessui/react').then((module) => ({ default: module.Transition.Child })));
const Dialog = lazy(() => import('@headlessui/react').then((module) => ({ default: module.Dialog })));
const DialogPanel = lazy(() => import('@headlessui/react').then((module) => ({ default: module.Dialog.Panel })));

interface Props {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
    styledTitle?: string;
    className?: string;
}

/**
 * @deprecated - use `Dialog` from `@wayste/sour-ui` instead
 */
export const DialogWrapper = ({ open, onClose, styledTitle, children, className = '' }: Props) => {
    const closeModal = () => {
        onClose();
    };

    return (
        <Suspense fallback={null}>
            <Transition appear show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={closeModal}>
                    <TransitionChild
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-50" />
                    </TransitionChild>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <TransitionChild
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <DialogPanel
                                    className={`max-h-96 w-full max-w-2xl transform overflow-auto rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all ${className}`}
                                >
                                    {styledTitle && (
                                        <div className="bg-sourgum-darkest-greyblue -mx-6 -mt-6 mb-3 rounded-t-2xl px-6 py-2.5 text-xl font-medium text-white">
                                            {styledTitle}
                                        </div>
                                    )}
                                    {children}
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </Suspense>
    );
};
